<wd-input-container [name]="name" [classes]="classes()" [label]="label" [helpText]="helpText()" [comments]="comments" [hideComments]="hideComments" [helpCurrentValue]="model" [helpFilter]="hbfFilter" (helpValueSelected)="onHelpValueSelected($event)">
	<ng-content select="[labelSuffix]" labelSuffix></ng-content>
	<input
		type="text"
		class="form-control"
		[(ngModel)]="model"
		#inputValue="ngModel"
		[ngClass]="classes()"
		[ngbTypeahead]="search"
		[editable]="true"
		[focusFirst]="true"
		(focusout)="onFocusOut()"
		[placement]="placement"
		container="body"
		[readonly]="disabled()"
		[attr.tabindex]="disabled() ? -1 : 0"
		(change)="onChange()"
		(mousedown)="onMouseDown($event)"
		(focus)="onFocus($event)"
		(click)="onClick($event)"
		[resultFormatter]="formatter"
		[inputFormatter]="formatter"
		(selectItem)="onSelect($event)"
		#thisInput
		#instance="ngbTypeahead"
	/>
</wd-input-container>
